<script>
	export let name;
	export let value;
</script>

<details>
	<summary>{name}: <b>{value}</b></summary>
	<slot></slot>
</details>